import { render, staticRenderFns } from "./LogoList.vue?vue&type=template&id=ec4f6ae2"
import script from "./LogoList.vue?vue&type=script&lang=ts"
export * from "./LogoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports